import {
  ASSETS_RETRIEVE,
  COMPANIES_ADDITIONAL_FIELDS_UPDATE,
  DOCUMENT_VERIFICATIONS_RETRIEVE,
  DOCUMENTS_RETRIEVE,
  EMAIL_GROUPS_RETRIEVE,
  USERS_RETRIEVE,
} from "./auth/permissions";
import AssetCrudPage from "./dashboard-pages/AssetPage";
import AssetSubtypeCrudPage from "./dashboard-pages/AssetSubtypePage";
import AssetTypeCrudPage from "./dashboard-pages/AssetTypePage";
import AssetTreePage from "./dashboard-pages/AssetTreePage";
import AuditPage from "./dashboard-pages/AuditPage";
import BarcodeFormPage from "./dashboard-pages/BarcodeFormPage";
import DashboardPage from "./dashboard-pages/DashboardPage";
import DocumentCategoryCrudPage from "./dashboard-pages/DocumentCategoryPage";
import DocumentCrudPage from "./dashboard-pages/DocumentPage";
import DocumentSpreadsheetPage from "./dashboard-pages/DocumentSpreadsheetPage";
import DocumentSubcategoryCrudPage from "./dashboard-pages/DocumentSubCategoryPage";
import DocumentVerificationPage from "./dashboard-pages/DocumentVerificationPage";
import SubcompanyCrudPage from "./dashboard-pages/SubcompanyPage";
import UserCrudPage from "./dashboard-pages/UserCrudPage";
import EmailGroupPage from "./dashboard-pages/EmailGroupPage";
import TagCrudPage from "./dashboard-pages/TagPage";
import CompanyAdditionalFieldsPage from "./dashboard-pages/CompanyAdditionalFieldsPage";

interface Route {
  path: string;
  exact?: boolean | undefined;
  name: string;
  component?: any;
  permissionName?: string;
}

interface RouteMap {
  [index: string]: Route;
}

const routes: RouteMap = {
  dashboard: {
    path: "/dashboard/",
    name: "Inicio",
    exact: true,
    component: DashboardPage,
  },
  users: {
    path: "/users/",
    name: "Usuarios",
    exact: true,
    component: UserCrudPage,
    permissionName: USERS_RETRIEVE,
  },
  audit: {
    path: "/audit/",
    name: "Auditoría",
    exact: true,
    component: AuditPage,
  },
  assetSubtypes: {
    path: "/asset_subtypes/",
    name: "Subtipos de activo",
    exact: true,
    component: AssetSubtypeCrudPage,
    permissionName: ASSETS_RETRIEVE,
  },
  assetTypes: {
    path: "/asset_types/",
    name: "Tipos de activo",
    exact: true,
    component: AssetTypeCrudPage,
    permissionName: ASSETS_RETRIEVE,
  },
  assets: {
    path: "/assets/",
    name: "Activos",
    exact: true,
    component: AssetCrudPage,
    permissionName: ASSETS_RETRIEVE,
  },
    assetTree: {
    path: "/assets_tree/",
    name: "Árbol de activos",
    exact: true,
    component: AssetTreePage,
    permissionName: ASSETS_RETRIEVE,
  },

  documentCategories: {
    path: "/document_categories/",
    name: "Categorías de documentos",
    exact: true,
    component: DocumentCategoryCrudPage,
    permissionName: DOCUMENTS_RETRIEVE,
  },
  documentSubcategories: {
    path: "/document_subcategories/",
    name: "Subcategorías de documentos",
    exact: true,
    component: DocumentSubcategoryCrudPage,
    permissionName: DOCUMENTS_RETRIEVE,
  },
  documents: {
    path: "/documents/",
    name: "Documentos",
    exact: true,
    component: DocumentCrudPage,
    permissionName: DOCUMENTS_RETRIEVE,
  },
  documentsSpreadsheet: {
    path: "/documents/spreadsheet/",
    name: "Documentos (Planilla)",
    exact: true,
    component: DocumentSpreadsheetPage,
    permissionName: DOCUMENTS_RETRIEVE,
  },
  documentVerifications: {
    path: "/document_verifications/",
    name: "Verificaciones de Documentos",
    exact: true,
    component: DocumentVerificationPage,
    permissionName: DOCUMENT_VERIFICATIONS_RETRIEVE,
  },
  subcompanies: {
    path: "/subcompanies/",
    name: "Sub Organizaciones",
    exact: true,
    component: SubcompanyCrudPage,
    permissionName: DOCUMENTS_RETRIEVE,
  },
  barcodePrint: {
    path: "/barcode_print/new/",
    name: "Imprimir Código de barras/QR",
    exact: true,
    component: BarcodeFormPage,
    permissionName: DOCUMENTS_RETRIEVE,
  },
  emailGroups: {
    path: "/email_groups/",
    name: "Grupos de Correo",
    exact: true,
    component: EmailGroupPage,
    permissionName: EMAIL_GROUPS_RETRIEVE,
  },
  tags: {
    path: "/tags/",
    name: "Tags de documentos",
    exact: true,
    component: TagCrudPage,
    permissionName: DOCUMENTS_RETRIEVE,
  },
  companyAdditionalFields: {
    path: "/company_additional_fields/",
    name: "Campos Adicionales",
    exact: true,
    component: CompanyAdditionalFieldsPage,
    permissionName: COMPANIES_ADDITIONAL_FIELDS_UPDATE,
  },
};

export const getRoutePath = (key: string) => {
  return routes[key].path;
};
export const getRouteName = (key: string) => {
  return routes[key].name;
};

export default routes;
